import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes__default from 'prop-types';

var _excluded = ["title", "pathRest"];
var IconPinSolid = function IconPinSolid(_ref) {
  var title = _ref.title,
    pathRest = _ref.pathRest,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: "hci-svg-pin-solid"
  }, rest), title && /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", _extends({
    d: "M12 2a7 7 0 0 0-7 7c0 3.87 7 13 7 13s7-9.13 7-13a7 7 0 0 0-7-7m0 10a3 3 0 1 1 0-6 3 3 0 0 1 0 6"
  }, pathRest)));
};
IconPinSolid.displayName = 'InlineIcon(IconPinSolid)';
IconPinSolid.propTypes = {
  title: PropTypes__default.string,
  pathRest: PropTypes__default.object
};

export { IconPinSolid };
